import React from "react";
import "./Root_Canel.css";
import Teeth_Whiting_img from "../images/pexels-cottonbro-5999363.jpg";
export default function ROOT_CANEL() {
  return (
    <div className="container_Teeth_Service_Root">
      <h1>ROOT CANAL</h1>
      <div className="teeth_img_upper_box_Service_Root">
        <img
          src={Teeth_Whiting_img}
          className="img_of_home_Service_Root"
          alt=""
        />
      </div>
      <div className="teeth_text_upper_main_Service_Root">
        <p>
          Root canal is a treatment to repair a spoiled tooth instead of
          clearing it. It is different to tooth extraction. The system
          incorporates clearing the effected part of the tooth and cleansing it,
          by then filling and settling it. Root trenches are the physical
          hollows inside a tooth that are normally possessed by nerve tissue,
          veins and other cell substances. It begins from cleaning of the
          trenches inside the tooth's root.
        </p>
        <h1>DID YOU KNOW??</h1>
        <p>
          The achievement rate of this method is just about 95%. In any case,
          specialized mastery and experience of the dental specialist is a
          central point that decides the result. For an effective result, it is
          fundamental that the root canal in the tooth root are wiped and
          sealed. The White dental practitioners are sufficiently experienced to
          expel the contaminated mash, find every one of the trenches, close
          them totally, and legitimately put a dental crown on it.
        </p>
        <div className="FAQ_Service_Root">
          <h2>FAQ'S</h2>
        </div>
      </div>
    </div>
  );
}
